import React from 'react';

const ShippingDelivery = () => (
  <div>
    <div className="page-header">
      <div className="container"><h1>Shipping &amp; Delivery</h1><p>Getting your parts to you, safely and on time</p></div>
    </div>
    <div className="policy-content">
      <h2>Processing Time</h2>
      <p>Orders are processed within 1-2 business days of confirmation. Parts are carefully packed to prevent damage in transit, especially fragile electrical and lighting components.</p>

      <h2>Delivery Timeline</h2>
      <p>Standard delivery typically takes 3-7 business days depending on your location and product availability. Delivery estimates are shown at checkout and may vary for remote areas.</p>

      <h2>Shipping Charges</h2>
      <p>Shipping charges (if any) are calculated at checkout and depend on your order value and payment method. Cash on Delivery orders may carry an additional COD handling fee.</p>

      <h2>Order Tracking</h2>
      <p>Once your order is shipped, you can track its status anytime using the Track Order page with your Order ID or registered phone number.</p>

      <h2>Delivery Issues</h2>
      <p>If your order is delayed, damaged in transit, or missing items, please contact our support team within 48 hours of delivery so we can resolve it quickly.</p>
    </div>
  </div>
);

export default ShippingDelivery;
